import { EmojiPicker } from './EmojiPicker';
import { EmojiKeyboard } from './EmojiKeyboard';
import en from './translation/en';
import pl from './translation/pl';
import ko from './translation/ko';
import it from './translation/it';
import fr from './translation/fr';
import id from './translation/id';
import es from './translation/es';
import de from './translation/de';
export { EmojiKeyboard };
export { en, pl, ko, it, fr, id, es, de };
export default EmojiPicker;
//# sourceMappingURL=index.js.map